import {
  Flex,
  useColorModeValue,
  useBreakpointValue,
  useTheme,
  Box,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import {
  BottomSheet,
  BottomSheetProps,
  BottomSheetRef,
} from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import useWindowDimensions from "../hooks/useFocusOnFeature";
import FavouriteButton from "./FavouriteButton";

type Props = Omit<BottomSheetProps, "open"> & {
  children: React.ReactNode;
};

const BottomSheetWrapper = ({
  children,
  expandOnContentDrag,
  blocking,
  ...props
}: Props) => {
  const theme = useTheme();
  const bottomSheetRef = useRef<BottomSheetRef>(null);
  const [prevMinHeight, setPrevMinHeight] = useState(0);

  // useEffect(() => {
  //   bottomSheetRef.current?.snapTo(({ minHeight }) => {
  //     return minHeight;
  //   });
  // }, [children, bottomSheetRef]);

  return (
    <Flex alignItems="center" justifyContent="center">
      <BottomSheet
        ref={bottomSheetRef}
        style={{
          //@ts-ignore
          "--rsbs-bg": useColorModeValue(
            "white",
            theme.colors?.["gray"]?.["900"]
          ),
          "--rsbs-max-w": "var(--chakra-sizes-container-md)",
          "--rsbs-ml": "auto",
          "--rsbs-mr": "auto",
        }}
        blocking={false}
        open
        snapPoints={({ minHeight, maxHeight }) => [
          minHeight,
          Math.min(maxHeight / 2, minHeight),
        ]}
        defaultSnap={({ minHeight }) => {
          if (minHeight !== prevMinHeight) {
            bottomSheetRef.current?.snapTo(minHeight);
            setPrevMinHeight(minHeight);
          }
          return minHeight;
        }}
        {...props}
      >
        <Box position="relative">{children}</Box>
      </BottomSheet>
    </Flex>
  );
};

export default BottomSheetWrapper;
